// SecurityLayersSection.jsx
import { motion } from "framer-motion";
const DatabaseIcon = () => (
  <svg
    className="w-[22px] h-[22px] text-white"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);

const LayersIcon = () => (
  <svg
    className="w-[22px] h-[22px] text-white"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 2 7 12 12 22 7 12 2" />
    <polyline points="2 17 12 22 22 17" />
    <polyline points="2 12 12 17 22 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    className="w-7 h-7 text-[#1A3F5C]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export default function SecurityLayersSection() {
  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center px-6 py-16"
      style={{ background: "linear-gradient(180deg,#eef1f6 0%,#f5f7fa 100%)" }}
    >
      {/* Header */}
      <h2 className="SecurityLayersSection_heading">
        Security built in layers
      </h2>
      <p className="SecurityLayersSection_subheading">
        Think of it like a building with multiple locks. We protect your data at
        the technology level and inside the product itself.
      </p>

      {/* Cards */}
      {/* w-full max-w-[1060px] flex flex-row md:flex-row items-center min-h-[280px] */}
      <div className=" Security_built_card">
        {/* LEFT — white card */}
        <motion.div
          initial={{ x: -40, opacity: 0 }}
          whileInView={{ x: 10, opacity: 1 }}
          whileHover={{
            x: 8, // same (upar hi rahega)
            x: -8, // LEFT move (opposite)
            rotate: -2, // reverse tilt
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          viewport={{ once: true }}
          // flex-1 bg-white border-2 border-[#E2E6EC] rounded-[20px] p-9 flex flex-col gap-5 min-h-[280px] relative z-10
          className="Technology_layer"
        >
          {/* Header row */}
          <div className="flex items-center gap-4">
            <div
              className="w-[52px] h-[52px] rounded-[14px] flex items-center justify-center shrink-0"
              style={{ background: "linear-gradient(145deg,#1E3A5F,#0F2A47)" }}
            >
              <DatabaseIcon />
            </div>
            <h3 className="text-[clamp(18px,2.2vw,24px)] font-extrabold text-[#0D1B2A] tracking-[-0.02em]">
              Technology layer
            </h3>
          </div>
          {/* Desc */}
          <p className="text-[14.5px] text-gray-600 leading-[1.65] flex-1">
            Secure cloud servers with locked storage, network protection, and
            backup systems.
          </p>
          {/* Bottom line */}
          <div
            className="h-[3px] rounded-full mt-auto"
            style={{
              background:
                "linear-gradient(90deg,#1A3F5C 0%,#5B8DB8 60%,#c8d8e8 100%)",
            }}
          />
        </motion.div>

        {/* Arrow connector */}
        <motion.div
          animate={{ x: [0, 10, 0] }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="hidden md:flex w-12 shrink-0 items-center justify-center relative z-20 mx-[-10px]"
        >
          <ArrowIcon />
        </motion.div>

        {/* RIGHT — dark navy card with dot pattern */}
        <motion.div
          whileHover={{
            y: -8, // halka upar
            y: 8, // slight right
            rotate: 2,
            // scale: 1.02, // minimal zoom
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          }}
          // flex-[1.1] rounded-[20px] p-9 flex flex-col gap-5 min-h-[280px] relative z-20 overflow-hidden Technology_layer_dotPatter
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          className="Technology_layer_dotPatter"
          style={{
            background: "#1A3F5C",
            boxShadow: "0 12px 40px rgba(15,42,71,0.22)",
          }}
        >
          {/* Dot pattern */}
          <motion.div
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage:
                "radial-gradient(circle, rgba(255,255,255,0.12) 1px, transparent 1px)",
              backgroundSize: "18px 18px",
            }}
            animate={{
              backgroundPosition: ["0px 0px", "40px 40px"], // diagonal movement
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "linear",
            }}
          />
          {/* Header row */}
          <div className="relative z-10 flex items-center gap-4">
            <div className="w-[52px] h-[52px] rounded-[14px] bg-white/15 flex items-center justify-center shrink-0">
              <LayersIcon />
            </div>
            <h3 className="text-[clamp(18px,2.2vw,24px)] font-extrabold text-white tracking-[-0.02em]">
              Product layer
            </h3>
          </div>
          {/* Desc */}
          <p className="relative z-10 text-[14.5px] text-white/75 leading-[1.65] flex-1">
            Controls who can see what, tracks what people do, and keeps work
            organized safely.
          </p>
          {/* Bottom line */}
          <div className="relative z-10 h-[2px] rounded-full bg-white/18 mt-auto" />
        </motion.div>
      </div>
    </section>
  );
}
